import React from "react";

export interface ConnectionStep {
  step: string;
  status: "pending" | "in-progress" | "success" | "error";
  message: string;
  timestamp: number;
  details?: any;
}

interface ConnectionStepsProps {
  steps: ConnectionStep[];
}

export const ConnectionSteps: React.FC<ConnectionStepsProps> = ({ steps }) => {
  if (steps.length === 0) {
    return null;
  }

  return (
    <div className="connection-steps-container">
      <h2>Connection Steps</h2>
      <div className="connection-steps-list">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`connection-step-item ${
              step.status === "error"
                ? "error"
                : step.status === "success"
                  ? "success"
                  : step.status === "in-progress"
                    ? "in-progress"
                    : "pending"
            }`}
          >
            <span className="connection-step-icon">
              {step.status === "error"
                ? "❌"
                : step.status === "success"
                  ? "✅"
                  : step.status === "in-progress"
                    ? "⏳"
                    : "⏸️"}
            </span>
            <div className="connection-step-content">
              <div className="connection-step-title">
                Step {step.step}: {step.message}
              </div>
              {step.details && (
                <div className="connection-step-details">
                  {JSON.stringify(step.details, null, 2)}
                </div>
              )}
              <div className="connection-step-timestamp">
                {new Date(step.timestamp).toLocaleTimeString()}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

